module.exports = __webpack_public_path__ + "static/media/madhavan-venkatesh.0ca62263.jpg";